import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ui-menu-cloud",
  "use": "ui-menu-cloud-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"ui-menu-cloud\"><g id=\"ui-menu-cloud_asus_proart_sw_ico_cloud\"><path d=\"M32.73,20.09H31.65a12.64,12.64,0,1,0-12,16.54h13.1a8.27,8.27,0,1,0,0-16.54Zm0,14.54H19.63a10.63,10.63,0,1,1,10.3-13.29,1,1,0,0,0,1,.75h1.83a6.27,6.27,0,1,1,0,12.54Z\" /><rect width=\"48\" height=\"48\" style=\"fill:none\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol